export default __webpack_public_path__ + "static/media/card-02.e8a9a50b.svg";